import qs from 'qs';
import AsyncValidator from 'async-validator';
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import print from 'print-js';
import axios from './axios';
import store from '../store/index';
import uploadFolder from './uploadFolder';

let loadingInstance = null;
let pendingRequests = [];

// 执行中的请求
let cancelTokenSource = null;

export default {
  // 获取高德地图中心和缩放
  getAMapCenterZoom: function () {
    const siteCode = Cookies.get('siteCode');
    // 亚太站
    if (siteCode === 'apac.prod') {
      return { center: [114.17034, 22.362306], zoom: 11.5 };
    }
    // 中国站（默认）
    return { center: [104.937478, 37.839575], zoom: 5 };
  },
  // 判断是否为欧洲站
  isEuropeSite() {
    const siteCode = Cookies.get('siteCode');
    return siteCode === 'eu.prod';
  },
  // 获取地图中心和缩放
  getGMapCenterZoom: function () {
    const siteCode = Cookies.get('siteCode');
    // 欧洲站
    if (siteCode === 'eu.prod') {
      return { center: { lat: 58.16132828686011, lng: 15.760018706623004 }, zoom: 4.5 };
    }
    // 美国站
    if (siteCode === 'us.prod') {
      return { center: { lat: 39.129843620119715, lng: -94.93187561399334 }, zoom: 5.2 };
    }
    // 亚太站
    if (siteCode === 'apac.prod') {
      return { center: { lat: 22.36256603480102, lng: 114.14795604062638 }, zoom: 11.5 };
    }
    // 英国站
    if (siteCode === 'uk.prod') {
      return { center: { lat: 54.6702497243253, lng: -4.23555410035204 }, zoom: 6.6 };
    }
    // 中国站（默认）
    return { center: { lat: 37.82285410414289, lng: 106.15931576295553 }, zoom: 5 };
  },
  // 日期选择器格式化（日期组件）
  getElFormat: function (format, isElement = true) {
    format = format || 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = store.state.dateFormat;
    let formatStr;
    if (format === 'YYYY-MM' || format === 'yyyy-MM') {
      formatStr = dateFormat.replace(/(.[Dd][Dd])|([Dd][Dd].)/g, '');
    } else {
      formatStr = format.replace(/[Yy]{4}-MM-[Dd]{2}/, dateFormat);
    }
    if (store.state.isTime24h !== '1' && formatStr.includes('H')) {
      formatStr = `${formatStr.replace(/H/g, 'h')} A`;
    }
    return isElement ? formatStr.replace(/Y/g, 'y').replace(/D/g, 'd') : formatStr.replace(/y/g, 'Y').replace(/d/g, 'D');
  },
  // 世界时间转本地时间（日期组件）
  momentElLocal: function (dataStr, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!dataStr) {
      return '-';
    }
    return moment.utc(dataStr).tz(store.state.timeZoneId).format(format);
  },
  // 世界时间转本地时间
  momentLocal: function (dataStr, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!dataStr) {
      return '-';
    }
    let formatStr = format.replace('YYYY-MM-DD', store.state.dateFormat);
    if (store.state.isTime24h !== '1' && formatStr.includes('H')) {
      formatStr = `${formatStr.replace(/H/g, 'h')} A`;
    }
    return moment.utc(dataStr).tz(store.state.timeZoneId).format(formatStr);
  },
  // 本地时区转世界时间
  momentWorld: function (dataStr, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!dataStr) {
      return '';
    }
    return moment(dataStr).tz(store.state.timeZoneId, true).utc().format(format);
  },
  // 时间值转格式不转时区（用于已经转换时间后）
  transFormat(dataStr, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!dataStr) {
      return '-';
    }
    let formatStr = format.replace('YYYY-MM-DD', store.state.dateFormat);
    if (store.state.isTime24h !== '1' && formatStr.includes('H')) {
      formatStr = `${formatStr.replace(/H/g, 'h')} A`;
    }
    return moment(dataStr).format(formatStr);
  },
  // 米/平方米/英尺/平方英尺 转本地
  formatLenLocal: function (value, isLen) {
    if (!value || value === '-') {
      return '-';
    }
    // USA站点((平方)米 => (平方)英尺)
    if (`${Cookies.get('nonMetric')}` === '1') {
      return isLen ? Math.round(Number.parseFloat(`${value}`) * 3.2808 * 10 ** 1) / 10 ** 1 : Math.round(Number.parseFloat(`${value}`) * 10.764 * 10 ** 2) / 10 ** 2;
    }
    // 其他站点((平方)米)
    return value;
  },
  // 米/平方米/英尺/平方英尺 转存储
  formatLenUpload: function (value, isLen) {
    if (!value) {
      return value;
    }
    // USA站点((平方)英尺  => (平方)米)
    if (`${Cookies.get('nonMetric')}` === '1') {
      return isLen ? Math.round((Number.parseFloat(`${value}`) / 3.2808) * 10 ** 1) / 10 ** 1 : Math.round((Number.parseFloat(`${value}`) / 10.764) * 10 ** 2) / 10 ** 2;
    }
    // 其他站点((平方)米)
    return value;
  },
  // 米/平方米/英尺/平方英尺
  formatLenUnit: function (tpl = '{unit}', isLen) {
    let unit = '';
    if (isLen) {
      unit = `${Cookies.get('nonMetric')}` === '1' ? 'ft' : 'm';
    } else {
      unit = `${Cookies.get('nonMetric')}` === '1' ? 'ft²' : 'm²';
    }
    const reg = new RegExp('{unit}', 'g');
    return tpl.replace(reg, unit);
  },
  // 摄氏度转华氏度
  celsiusToFahrenheit: function (value) {
    if (!value) {
      return value;
    }
    // 美国环境温度转华氏度
    if (`${Cookies.get('nonMetric')}` === '1') {
      return parseFloat((1.8 * Number(value) + 32).toFixed(1));
    }
    return value;
  },
  // 华氏度转摄氏度
  fahrenheitToCelsius: function (value) {
    if (!value) {
      return value;
    }
    // 美国环境温度转华氏度
    if (`${Cookies.get('nonMetric')}` === '1') {
      return parseFloat((Number(value) - 32) * (5 / 9).toFixed(1));
    }
    return value;
  },
  // 温度单位 摄氏度 华氏度
  formatTempUnit: function () {
    let unit = '';
    unit = `${Cookies.get('nonMetric')}` === '1' ? '℉' : '℃';
    return unit;
  },
  getJSON: function (url, data, isLoading) {
    if (isLoading) {
      if (pendingRequests.includes(url)) {
        return new Promise(() => {});
      }
      pendingRequests.push(url);
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: data || {},
          paramsSerializer: function (params) {
            return qs.stringify(params, {
              arrayFormat: 'repeat',
            });
          },
        })
        .then(
          (response) => {
            if (isLoading) {
              pendingRequests = pendingRequests.filter((t) => t !== url);
            }
            resolve(response.data);
          },
          (err) => {
            if (isLoading) {
              pendingRequests = pendingRequests.filter((t) => t !== url);
            }
            reject(err);
          }
        );
    });
  },
  postJSON: function (url, data, isLoading) {
    if (isLoading) {
      if (pendingRequests.includes(url)) {
        return new Promise(() => {});
      }
      pendingRequests.push(url);
    }
    return new Promise((resolve, reject) => {
      axios.post(url, data || {}).then(
        (response) => {
          if (isLoading) {
            pendingRequests = pendingRequests.filter((t) => t !== url);
          }
          resolve(response.data);
        },
        (err) => {
          if (isLoading) {
            pendingRequests = pendingRequests.filter((t) => t !== url);
          }
          reject(err);
        }
      );
    });
  },
  putJSON: function (url, data) {
    return new Promise((resolve, reject) => {
      axios.put(url, data || {}).then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  deleteJSON: function (url, data) {
    return new Promise((resolve, reject) => {
      axios
        .delete(url, {
          data: data || {},
        })
        .then(
          (response) => {
            resolve(response.data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  },
  /**
    * @description 文件上传
    * @param {string} url ajax请求地址
    * @param {Event} e 表单提交事件，文件上传表单@change事件参数(或者file), 文件name值默认挂载file值上
    * @param {object} param 表单携带的其他参数
    * @returns {Promise} result Promise对象
    * @example
      this.$postFile('/upload', e).then((data)=> {
        if(data.errcode === 0){
          this.$toast('上传成功');
          return;
        };
      });
      */
  postFile: function (url, e, param = {}) {
    const file = e.target && e.target.files ? e.target.files[0] : e;
    const data = new FormData(); // 创建form对象
    // 通过append向form对象添加数据，可继续添加其他json等数据
    data.append('file', file);
    Object.keys(param).forEach((key) => {
      data.append(key, param[key]);
    });
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return new Promise((resolve, reject) => {
      axios.post(url, data, config).then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  /**
   * @description 上传文件，返回文件地址信息
   * @param {Object} evt file event对象
   * @param {Object} param ossConfig配置信息
   * @param {Function} progress 上传进度回调
   * @return {Promise} result Promise对象
   * @param {Object} resolveRet reslove对象
   * @param {String} resolveRet.attachName 上传文件名称
   * @param {String} resolveRet.attachPath 文件上传后，可访问的完整地址
   */
  postOss: function (evt, param = {}, progress) {
    const file = evt.target && evt.target.files ? evt.target.files[0] : evt;
    const nameArr = file.name.split('.');
    const fileType = nameArr[nameArr.length - 1];

    const uuid = this.getUUID();
    const fileName = uuid.replace(/\-/g, '').toUpperCase();
    const newFile = new File([file], `${fileName}.${fileType}`, {
      type: file.type,
    });

    const data = new FormData();
    Object.keys(param).forEach((key) => {
      data.append(key, param[key]);
    });
    data.append('file', newFile);
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 1000000,
      onUploadProgress: (progressEvent) => {
        // 监听上传进度
        if (progress) {
          progress(progressEvent);
        }
      },
    };
    return new Promise((resolve, reject) => {
      axios.post(param.host, data, config).then(
        (response) => {
          const fileItem = response.data.data;
          fileItem.name = file.name;
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  getDebounceJSON: function (url, data) {
    // 如果有正在进行的请求，取消上一个请求
    if (cancelTokenSource) {
      cancelTokenSource.cancel();
    }

    // 创建一个新的取消令牌
    cancelTokenSource = axios.CancelToken.source();
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: data || {},
          cancelToken: cancelTokenSource.token, // 使用取消令牌
          paramsSerializer: function (params) {
            return qs.stringify(params, {
              arrayFormat: 'repeat',
            });
          },
        })
        .then(
          (response) => {
            resolve(response.data);
          },
          (err) => {
            // 如果是请求被取消，忽略错误
            if (axios.isCancel(err)) {
              return;
            }
            reject(err);
          }
        );
    });
  },

  /**
    * @description 深度拷贝
    * @param {object} data 数据对象
    * @return {object} result 拷贝的对象
    * @example
      const data = this.$getFormatData(this.form);
    */
  getFormatData: function (data) {
    return JSON.parse(JSON.stringify(data));
    // 或者return Object.assign({}, data)
  },
  /**
    * @description 获取对象内指定的字段并赋值(当包含不存在的字段时默认填充null,如果想保留原数据可用str字段不包含实现)
    * @param {object} todata 需要赋值的对象
    * @param {object} data 数据对象（数据源）
    * @param {String} str 赋值的字段名用多个用逗号隔开(没有该参数时，默认为todata的属性集合)
    * @example
      this.$setFormatData(this.syncForm, data.retobj, 'brandName,originPlace,manufactorID');
    */
  setFormatData: (todata, data, str) => {
    if (typeof str === 'string') {
      const keys = str.split(',');
      keys.forEach((t) => {
        todata[t] = typeof data[t] === 'undefined' ? null : data[t];
      });
      return;
    }
    const propertys = Object.getOwnPropertyNames(todata);
    propertys.forEach((t) => {
      if (typeof data[t] !== 'undefined') {
        todata[t] = data[t];
      }
    });
  },
  /**
   * @description 倒计时
   * @param {number} num 初始数字
   * @param {function} cb 每秒执行方法，参数为初始数字的递减后的值
   * @example
     this.$countdown(60, (data)=> {
        console.log(data);
     })
   */
  countdown: function (num, cb) {
    cb(num);
    const IntervalName = setInterval(() => {
      num--;
      if (!num) {
        clearInterval(IntervalName);
      }
      cb(num);
    }, 1000);
  },
  /**
   * @description 生成随机数(指定长度)
   * @param {number} len 随机数长度
   * @return {number} 生成的随机数
   * @example
     const key = this.$randomNum(8)
   */
  randomNum: function (len) {
    len = len || 5;
    return Number.parseInt(Math.random() * 10 * len, 10);
  },
  /**
   * @description 文件导出
   * @param {string} url 请求地址
   * @param {object} data 请求提交的参数
   * @return {Promise} 返回结果
   * @example
     async exportCard (){
      await this.$exportFlie('/buss/test', this.form.Search)
     }
   */
  // 文件导出 [GET]
  exportFlie: function (url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        params: data,
        paramsSerializer: function (params) {
          return qs.stringify(params, {
            arrayFormat: 'repeat',
          });
        },
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(
        (res) => {
          if (res.headers['content-disposition']) {
            const filename = res.headers['content-disposition'].toString().replace('attachment;filename=', '');
            const blob = new Blob([res.data]);
            const elink = document.createElement('a');
            elink.download = decodeURIComponent(filename); // 文件名解码
            elink.href = URL.createObjectURL(blob);
            elink.style.display = 'none';
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL对象
            document.body.removeChild(elink);
            resolve(decodeURIComponent(filename));
          } else {
            reject();
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  // 文件导出 [POST]
  exportFliePost: function (url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        data: data,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          if (res.data && ((res.data.size && res.data.size < 100) || !res.data.size)) {
            const blob = new Blob([res.data]);
            const reader = new FileReader();
            reader.readAsText(blob, 'utf-8');
            reader.onload = () => {
              const jsonStr = reader.result;
              const rejectData = JSON.parse(jsonStr);
              reject(rejectData);
            };
          } else {
            const filename = res.headers['content-disposition'].toString().replace('attachment;filename=', '');
            const blob = new Blob([res.data]);
            const elink = document.createElement('a');
            elink.download = decodeURIComponent(filename); // 文件名解码
            elink.href = URL.createObjectURL(blob);
            elink.style.display = 'none';
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL对象
            document.body.removeChild(elink);
            resolve(decodeURIComponent(filename));
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  // html转pdf
  exportPdf: function (ele, pdfName = 'pdf', pageType = 'a4') {
    const dom = document.querySelector(ele);
    const eleW = dom.offsetWidth; // 获得该容器的宽
    const eleH = dom.offsetHeight; // 获得该容器的高
    const eleOffsetTop = dom.offsetTop; // 获得该容器到文档顶部的距离
    const eleOffsetLeft = dom.offsetLeft; // 获得该容器到文档最左的距离
    // a4纸尺寸
    const a4Size = {
      width: 592.28,
      height: 841.89,
    };
    // a5纸尺寸
    const a5Size = {
      width: 417.42,
      height: 592.28,
    };
    const sizeConf = pageType === 'a4' ? a4Size : a5Size;
    var canvas = document.createElement('canvas');
    var abs = 0;
    const winIn = document.documentElement.clientWidth || document.body.clientWidth; // 获得当前可视窗口的宽度（不包含滚动条）
    const winout = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）
    if (winout > winIn) {
      // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
      abs = (winout - winIn) / 2; // 获得滚动条宽度的一半
      // console.log(a, '新abs');
    }

    canvas.width = eleW * 2; // 将画布宽&&高放大两倍
    canvas.height = eleH * 2;
    var context = canvas.getContext('2d');
    context.scale(2, 2);
    context.translate(-eleOffsetLeft - abs, -eleOffsetTop);
    // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
    // translate的时候，要把这个差值去掉

    // html2canvas(element).then( (canvas)=>{ //报错
    // html2canvas(element[0]).then( (canvas)=>{
    return html2Canvas(dom, {
      dpi: 600,
      scale: 2,
      // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
      useCORS: true, // 允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
      // eslint-disable-next-line no-shadow
    }).then((canvas) => {
      var contentWidth = canvas.width;
      var contentHeight = canvas.height;
      // 一页pdf显示html页面生成的canvas高度;
      var pageHeight = (contentWidth / sizeConf.width) * sizeConf.height;
      // 未生成pdf的html页面高度
      var leftHeight = contentHeight;
      // 页面偏移
      var position = 0;
      // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      var imgWidth = sizeConf.width;
      var imgHeight = (sizeConf.width / contentWidth) * contentHeight;
      var pageData = canvas.toDataURL('image/jpeg', 1.0);
      var pdf = new JsPDF('', 'pt', pageType);
      // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
      // 当内容未超过pdf一页显示的范围，无需分页
      if (leftHeight < pageHeight) {
        // 在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);
      } else {
        // 分页
        while (leftHeight > 0) {
          pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= sizeConf.height;
          // 避免添加空白页
          if (leftHeight > 0) {
            pdf.addPage();
          }
        }
      }
      // 可动态生成
      pdf.save(pdfName);
    });
  },
  getLevel1Span(arr) {
    var start = 0;
    var ret = [];
    arr.forEach((i) => {
      var temp = {};
      i.children.forEach((j, jIndex) => {
        j.children.forEach((k, kIndex) => {
          if (jIndex === 0 && kIndex === 0) {
            temp.start = start;
          }
          start++;
        });
      });
      temp.end = start - 1;
      ret.push(temp);
    });
    return ret;
  },
  getLevel2Span(arr) {
    var start = 0;
    var ret = [];
    arr.forEach((i) => {
      i.children.forEach((j) => {
        var temp = {};
        j.children.forEach((k, kIndex) => {
          if (kIndex === 0) {
            temp.start = start;
          }
          start++;
        });
        temp.end = start - 1;
        ret.push(temp);
      });
    });
    return ret;
  },
  treeToList(tree, column) {
    const ret = [];
    let index = 0;
    tree.forEach((i, iIndex) => {
      i.children.forEach((j, jIndex) => {
        j.children.forEach((k, kIndex) => {
          const vals = [i.langCode, j.langCode, k.langCode, k.value, k.isNormal];
          const row = {
            index: index++,
          };
          vals.forEach((val, valIndex) => {
            row[column[valIndex].columnCode] = val;
          });
          row.iIndex = iIndex;
          row.jIndex = jIndex;
          row.kIndex = kIndex;
          ret.push(row);
        });
      });
    });
    return ret;
  },
  listToTree(list) {
    const baseTree = [];
    const map = {};
    list.forEach((i) => {
      if (!map[i.iIndex]) {
        map[i.iIndex] = [];
      }
      map[i.iIndex].push(i);
    });
    Object.keys(map).forEach((key) => {
      baseTree.push({
        langCode: map[key][0].test_module,
        children: [],
      });
    });
    const iIndexArr = this.$splitArrByKey(list, 'iIndex');
    iIndexArr.forEach((item, index) => {
      const children = this.$splitArrByKey(item, 'jIndex');
      baseTree[index].children = children.map((obj) => ({
        langCode: obj[0].test_classify,
        children: obj.map((inst) => ({
          langCode: inst.test_items,
          value: inst.test_value,
          isNormal: inst.is_normal,
          children: [],
        })),
      }));
    });

    return baseTree;
  },
  /**
   * @description 将数组按key字段的值进行分组,key字段值相同的为一组
   * @param {Array} arr 带分组的数组
   * @param {String} key 分组标志
   * @return {Array<Array>} result
   */
  splitArrByKey(arr, key) {
    const ret = [];
    let baseValue = '';
    let tempArr = [];
    arr.forEach((item) => {
      if (item[key] !== baseValue) {
        if (tempArr.length) {
          ret.push([...tempArr]);
        }
        baseValue = item[key];
        tempArr = [];
        tempArr.push(item);
      } else {
        tempArr.push(item);
      }
    });
    if (tempArr.length) {
      ret.push([...tempArr]);
    }
    return ret;
  },
  // 验证时间格式HHmm
  formateCheckHHmm(str) {
    const re = /^(?:[01]\d|2[0-3])(?::[0-5]\d)$/;
    const result = re.test(str) ? str : '';
    return result;
  },
  // 验证时间格式 yyyyMMddHHmm
  formateCheckyyyyMMddHHmm(str) {
    const re = /^\d{4,}\-(?:0?\d|1[12])\-(?:[012]?\d|3[01]) (?:[01]?\d|2[0-4]):(?:[0-5]?\d|60)$/;
    const result = re.test(str) ? str : '';
    return result;
  },
  // 验证时间格式 yyyyMMddHHmmss
  formateCheckyyyyMMddHHmmss(str) {
    const re = /^\d{4}-(0\d|1[0-2])-([0-2]\d|3[01])( ([01]\d|2[0-3])\:[0-5]\d\:[0-5]\d)$/;
    const result = re.test(str) ? str : '';
    return result;
  },
  // 表单验证
  validator: async function (descriptor, form) {
    const asyncValidator = new AsyncValidator(descriptor);
    return new Promise((resolve) => {
      asyncValidator
        .validate(form)
        .then(() => {
          resolve();
        })
        .catch(({ errors }) => {
          resolve(errors);
        });
    });
  },
  // 树转列表
  treeTransArray(tree, key) {
    return tree.reduce(function merge(con, item) {
      con.push(item);
      if (item[key] && item[key].length > 0) {
        item[key].reduce(merge, con);
      }
      return con;
    }, []);
  },
  // 列表转对象
  listTransObject(list, keyName = 'value', valueName = 'name') {
    if (!Array.isArray(list)) {
      return {};
    }
    const data = {};
    list.forEach((item) => {
      data[`${item[keyName]}`] = item[valueName];
    });
    return data;
  },
  // 字典的列表转对象{value: name}
  transformDicValue(list) {
    if (!Array.isArray(list)) {
      return {};
    }
    const data = {};
    list.forEach((item) => {
      data[item.value] = item.name;
    });
    return data;
  },
  // 字典的列表转对象{code: value}
  transformDicCode(list) {
    if (!Array.isArray(list)) {
      return {};
    }
    const data = {};
    list.forEach((item) => {
      data[item.code] = item.value;
    });
    return data;
  },
  // 添加class
  toggleClass(element, className) {
    if (!element || !className) {
      return;
    }
    let classString = element.className;
    const nameIndex = classString.indexOf(className);
    if (nameIndex === -1) {
      classString += `${className}`;
    } else {
      classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
    }
    element.className = classString;
  },
  /**
   * @description 获取网页url中?号传值中的value
   * @param {String} name key
   * @return {String} ret
   */
  getQueryString: function (name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    const r = window.location.search.substr(1).match(reg); // 获取url中"?"符后的字符串并正则匹配
    let context = '';
    if (r !== null) {
      context = r[2];
    }
    return context;
  },
  // 生成唯一标识
  genNonDuplicateID: function () {
    return Number(Math.random().toString().substr(3, 10) + Date.now()).toString(36);
  },
  // 打开 全屏loading蒙版
  showLoading(
    options = {
      fullscreen: true,
    }
  ) {
    loadingInstance = this.$loading(options);
  },
  // 关闭 全屏loading蒙版
  closeLoading() {
    if (loadingInstance) {
      loadingInstance.close();
    }
  },
  /**
   * @description element $confirm封装
   * @param {String} msg 显示内容
   * @param {String} title title，默认：提示；非必填
   * @param {Oject} options element $confirm config option；非必填
   * @return {Promise} 确定时执行resolve(true), 取消时，执行catch
   */
  showConfirm(msg, title, options = {}) {
    let message = '';
    if (Array.isArray(msg)) {
      const newDatas = [];
      const h = this.$createElement;
      for (const i in msg) {
        newDatas.push(h('p', null, msg[i]));
      }
      message = h('div', null, newDatas);
    } else {
      message = msg;
    }

    const curTitle = !title ? this.i18n.com_reminder : title;
    const opts = Object.assign(
      {
        confirmButtonText: this.i18n.com_confirm,
        cancelButtonText: this.i18n.com_cancel,
        closeOnClickModal: false,
        type: 'warning',
      },
      options
    );
    return this.$confirm(message, curTitle, opts).then(() => true);
  },
  /**
   * @description 复制内容到粘贴板
   * @param {String} content 复制内容
   * @param {String | Null | Boolean} message 复制成功后提示的信息；如果为null或者false，则不提示
   */
  copyToClip(content, message) {
    // 动态创建 textarea 标签
    const textarea = document.createElement('textarea');
    // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
    textarea.readOnly = 'readonly';
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    // 将要 copy 的值赋给 textarea 标签的 value 属性
    // 网上有些例子是赋值给innerText,这样也会赋值成功，但是识别不了\r\n的换行符，赋值给value属性就可以
    textarea.value = content;
    // 将 textarea 插入到 body 中
    document.body.appendChild(textarea);
    // 选中值并复制
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    document.execCommand('Copy');
    document.body.removeChild(textarea);

    if (message) {
      this.$message({
        message: message,
        type: 'success',
      });
    }
  },
  // 创建ws
  connectWebSocketClass(url, msgCallback, name) {
    const context = this;
    class WebSocketClass {
      /**
       * @description: 初始化实例属性，保存参数
       * @param {String} url ws的接口
       * @param {Function} msgCallback 服务器信息的回调传数据给函数
       * @param {String} name 可选值 用于区分ws，用于debugger
       */
      constructor() {
        this.url = url;
        this.msgCallback = msgCallback;
        this.name = name;
        this.ws = null; // websocket对象
        this.status = null; // websocket是否关闭
        this.count = 0;
      }

      connect(data = 'connect') {
        // 新建 WebSocket 实例
        this.ws = new WebSocket(this.url);
        this.ws.onopen = () => {
          // 连接ws成功回调
          this.status = 'open';
          // console.log(`${this.name}连接成功`, e);
          this.heartCheck();
          if (data !== undefined) {
            // 有要传的数据,就发给后端
            return this.ws.send(data);
          }
          return true;
        };
        // 监听服务器端返回的信息
        this.ws.onmessage = (e) => {
          this.msgCallback(e.data);
        };
        // ws关闭回调
        this.ws.onclose = (e) => {
          ++this.count;
          // 连不上 间隔1分钟再连接
          this.changeHandler = context.$debounce(this.closeHandle, 10000);
          this.changeHandler(e);
        };
        // ws出错回调
        this.onerror = (e) => {
          ++this.count;
          this.closeHandle(e); // 判断是否关闭
        };
      }

      heartCheck() {
        // 心跳机制的时间可以自己与后端约定
        this.pingPong = 'ping'; // ws的心跳机制状态值
        this.pingInterval = setInterval(() => {
          if (this.ws.readyState === 1) {
            // console.log('发出keepAlive');
            // 检查ws为链接状态 才可发送
            this.ws.send('keepAlive'); // 客户端发送ping
          }
        }, 60000);
        this.pongInterval = setInterval(() => {
          this.pingPong = false;
          if (this.pingPong === 'ping') {
            const tips = context.$t('com_ws_pingpong_close_tips');
            // const tips = context.$t('pingPong没有改变为pong');
            ++this.count;
            this.closeHandle(tips); // 没有返回pong 重启webSocket
          }
          // 重置为ping 若下一次 ping 发送失败 或者pong返回失败(pingPong不会改成pong)，将重启
          // console.log('返回pong');
          this.pingPong = 'ping';
        }, 20000);
      }

      // 发送信息给服务器
      sendHandle(data) {
        // console.log(`${this.name}发送消息给服务器:`, data)
        return this.ws.send(data);
      }

      // 关闭连接
      closeHandle() {
        // 因为webSocket并不稳定，规定只能手动关闭(调closeMyself方法)，否则就重连
        if (this.status !== 'close') {
          // console.log(`${this.name}断开，重连websocket`);
          if (this.pingInterval !== undefined && this.pongInterval !== undefined) {
            // 清除定时器
            clearInterval(this.pingInterval);
            clearInterval(this.pongInterval);
          }
          // 超过10次 一次一分钟后就不重新连接了
          if (this.count < 10) {
            this.connect(); // 重连
          }
        } else {
          // console.log(`${this.name}websocket手动关闭`);
        }
      }

      // 手动关闭WebSocket
      closeMyself() {
        // console.log(`关闭${this.name}`);
        this.status = 'close';
        return this.ws.close();
      }
    }
    return new WebSocketClass(url, msgCallback, name);
  },

  // 获取文件列表
  getFileList({ bizId, bizType }) {
    if (!bizId || !bizType) {
      return false;
    }
    return this.$getJSON(`${apis.OssAttach}/${bizId}/${bizType}`).then((res) => {
      const list = res.data;
      list.forEach((item) => {
        item.name = item.attachName;
        item.url = this.getAttachUrl(item);
        item.bizType = bizType;
      });
      return list;
    });
  },
  /**
   * @description 下载文件
   * @param {String} url 文件的可访问地址,必填项
   * @param {String} fileName 下载后的文件名,非必填项
   */
  downloadFile(url, fileName = '') {
    const link = document.createElement('a');
    link.download = fileName;
    link.style.display = 'none';
    link.href = url;
    // 触发点击
    document.body.appendChild(link);
    link.click();
    // 移除节点
    document.body.removeChild(link);
  },
  /**
   * @description 返回防抖函数
   * @param {Function} fn 执行函数，必填项
   * @param {Number} wait 时间间隔，必填项
   * @return {Function} 返回的防抖函数
   */
  debounce(fn, wait) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args); // 把参数传进去
      }, wait);
    };
  },
  /**
   * @description 将传入的promise对象包装成新的promise对象。当旧promise对象执行reject时，
   * 新promise对象执行resolve(false);当就promise对象执行resolve时，新promise对象执行resolve(true)
   * @param {Promise} p 旧promise对象
   * @return {Promise} 新promise对象
   */
  boolPromise(p) {
    return p.then(() => true).catch(() => Promise.resolve(false));
  },
  /**
   * 检测keys中的键，是否在obj中找到对应的值
   * @param {Array} keys
   * @param {Object} obj
   * @param {Boolean} logDiff 是否打印keys在obj中找不到的项
   * @return {Boolean} ret
   */
  checkObjectValues(keys, obj, logDiff) {
    let flag = true;
    const diffList = [];
    keys.forEach((key) => {
      if (!obj[key]) {
        flag = false;
        diffList.push({
          key,
          val: obj[key],
        });
      }
    });
    if (logDiff) {
      // eslint-disable-next-line no-console
      console.log(diffList);
    }
    return flag;
  },
  /**
   * 数组对象指定字段默认同上
   * @param {Array} list 数据源
   * @param {Array} keys 同上字段名
   * @return {Boolean} 同步字段后的数组
   */
  formatCopyUp: function (list, keys = []) {
    const arr = JSON.parse(JSON.stringify(list));
    const storage = {};
    arr.forEach((item) => {
      keys.forEach((key) => {
        if (item[key]) {
          storage[key] = item[key];
        } else {
          item[key] = storage[key] || '';
        }
      });
    });
    return arr;
  },
  /*
   * 判断是否为图片格式
   * @param {String} str 文件地址
   */
  isImage: function (str) {
    const reg = /\.(png|jpg|gif|jpeg|webp)$/;
    return reg.test(str);
  },

  /*
   * 数字转大写
   * @param {Number} 金额
   */
  moneyToCapital: function (n) {
    if (n === 0) {
      return '零';
    }
    if (!(/^(0|[1-9]\d*)(\.\d+)?$/).test(n)) {
      return '';
    }
    var unit = '千百拾亿千百拾万千百拾元角分',
      str = '';
    n += '00';
    var p = n.indexOf('.');
    if (p >= 0) {
      n = n.substring(0, p) + n.substr(p + 1, 2);
    }
    unit = unit.substr(unit.length - n.length);
    for (var i = 0; i < n.length; i++) {
      str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
    }
    return str
      .replace(/零(千|百|拾|角)/g, '零')
      .replace(/(零)+/g, '零')
      .replace(/零(万|亿|元)/g, '$1')
      .replace(/(亿)万|壹(拾)/g, '$1$2')
      .replace(/^元零?|零分/g, '')
      .replace(/元$/g, '元整');
  },
  // 异步加载js
  // loadJS('file.js',function(){  alert(1) });
  loadJS(url, callback) {
    var script = document.createElement('script'),
      fn = callback || function () {};
    script.type = 'text/javascript';
    // IE
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          fn(window);
        }
      };
    } else {
      // 其他浏览器
      script.onload = function () {
        fn(window);
      };
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  },

  /**
   * 根据attachId批量获取文件
   * @param {string} attachIds attachId集合，多个id用逗号隔开
   * @return {array<object>} ret
   */
  getAttachFileList(attachIds) {
    return this.$getJSON(apis.attachList, {
      attachIds,
    }).then((res) => res.data);
  },
  // 根据attachId获取单个文件
  getAttachFile(attachId) {
    return this.$getAttachFileList(attachId).then((data) => data[0]);
  },
  /**
   * 根据bizIds bizType批量获取文件
   * @param {string} bizIds bizIds集合，多个id用逗号隔开
   * @param {string} bizType 业务类型
   * @return {array<object>} ret
   */
  getAttachFileListType(bizIds, bizType) {
    return this.$getJSON(apis.attachBizList, {
      bizIds,
      bizType,
    }).then((res) => res.data);
  },
  /**
   * 根据 biztype 获取 上传文件夹
   * @param {string} biztype attachId集合，多个id用逗号隔开
   * @return {string} uploadFolder
   */
  getUploadFolder(biztype) {
    let folder = '';
    if (biztype) {
      folder = uploadFolder[biztype];
    }
    if (folder.includes('YYYYMMDD')) {
      folder = this.formatSrtYYYYMMDD(folder);
    }
    if (folder.includes('YYYYMM')) {
      folder = this.formatSrtYYYYMM(folder);
    }
    return folder;
  },

  /*
   * 根据 filename 获取文件后缀名
   * @param {string} filename 文件名
   * @return {string} extName
   */
  getExtname(filename) {
    if (!filename || typeof filename != 'string') {
      return false;
    }
    const str = filename.split('').reverse().join('');
    const extName = str.substring(0, str.search(/\./)).split('').reverse().join('');
    return extName;
  },
  /*
   * 根据 Second 格式化成h:m
   * @param {Number} Second 秒
   * @return {string} h:m格式化
   */
  formatSecToHm(s) {
    if (!s || s === '-') {
      return s;
    }
    let t;
    // 如果秒数不满一分钟按一分钟算
    if (s > -1 && s < 60) {
      t = '00:01';
    } else {
      const hour = Math.floor(s / 3600);
      const min = Math.floor(s / 60) % 60;
      // let sec = s % 60;
      if (hour < 10) {
        t = `0${hour}:`;
      } else {
        t = `${hour}:`;
      }
      if (min < 10) {
        t += '0';
      }
      t += min;
      // if(sec < 10){t += "0";}
      // t += sec.toFixed(2);
    }
    return t;
  },
  /*
   * 根据 Second 格式化成h:m
   * @param {Number} Second 秒
   * @return {string} h:m格式化
   */
  formatSecToMin(s) {
    let t;
    if (s > -1) {
      const min = Math.floor(s / 60);
      return min;
      // if(sec < 10){t += "0";}
      // t += sec.toFixed(2);
    }
    return t;
  },
  /*
   * 打印 Print
   * @param {dom} css dom
   * Print
   */
  onPrint(ele) {
    // printJs转图片打印
    // const printContent = this.$refs[printDom];
    const printContent = document.querySelector(ele);
    // 获取dom 宽度 高度
    const width = printContent.clientWidth;
    const height = printContent.clientHeight;
    // 创建一个canvas节点
    const canvas = document.createElement('canvas');

    const scale = 2; // 定义任意放大倍数，支持小数；越大，图片清晰度越高，生成图片越慢。
    canvas.width = width * scale; // 定义canvas 宽度 * 缩放
    canvas.height = height * scale; // 定义canvas高度 *缩放
    canvas.style.width = `${width * scale}px`;
    canvas.style.height = `${height * scale}px`;
    canvas.getContext('2d').scale(scale, scale); // 获取context,设置scale

    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 获取滚动轴滚动的长度
    const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft; // 获取水平滚动轴的长度
    html2Canvas(printContent, {
      canvas,
      backgroundColor: null,
      useCORS: true,
      windowHeight: document.body.scrollHeight,
      scrollX: -scrollLeft, // 解决水平偏移问题，防止打印的内容不全
      scrollY: -scrollTop,
      /* eslint-disable */
    })
      .then((canvas) => {
        const url = canvas.toDataURL('image/png');
        print({
          printable: url,
          type: 'image',
          documentTitle: '', // 标题
          // 确保打印样式里没有额外的 margin 挤占空间
          style: '@page{size:auto;margin: 0cm 1cm 0cm 1cm;} body{margin:0;}', // 去除页眉页脚
        });
      })
      .catch((err) => {
        console.error(err);
      });
  },
  /*
   * 根据 area 格式化成平方单位
   * @param {Number} area 面积
   * @return {string} 面积平方格式化
   */
  formatAreaToUnit(area) {
    return `${this.$formatLenLocal(area)} ${this.$formatLenUnit()}`;
  },
  /*
   * 根据 num 格式化小数 默认四舍五入
   * @param {Number} num 数字
   * @param {Number} decimal 保留的小数点后几位
   * @return {Number} 小数格式化后的数字
   */
  toFixed(num, decimal = 2) {
    // eslint-disable-next-line no-restricted-globals
    if (!num || isNaN(num)) {
      return 0;
    }
    return +num.toFixed(decimal);
  },
  /*
   * 根据 attachPath 返回attachPath不带http全路径.com/后面到? 只要文件夹+文件名
   * @param {String} attachPath 路径
   * @return {String} 文件夹+文件名
   */
  formatAttachPath(path) {
    if (!path) {
      return '';
    }
    if (path.indexOf('http') === -1) {
      return path;
    } else {
      const reg = new RegExp('(?<=.com/)[^?]*', 'g');
      return path.match(reg)[0];
      // return path.match(/(?<=\.com\/)[^?]*/)[0];
    }
  },
  /*
   * 根据 attachPath 返回文件名
   * @param {String} path 路径
   * @return {String} 文件夹
   */
  formatAttachName(attachPath) {
    if (!attachPath) {
      return '';
    }
    if (attachPath.indexOf('http') === -1) {
      return attachPath.match(/[^\/.]*\..*/)[0];
    } else {
      const reg = new RegExp('(?<=.com/)[^?]*', 'g');
      return attachPath.match(reg)[0].match(/[^\/.]*\..*/)[0];
      // return attachPath.match(/(?<=\.com\/)[^?]*/)[0].match(/[^\/.]*\..*/)[0];
    }
  },
  /*
   * 手机号电话验证验证 支持座机和手机号
   */
  mobilePhoneValidator(rule, value, callback) {
    const isPhone = /^([0-9]{3,4})?(-)?[0-9]{7,8}$/;
    const isMob = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
    const regx = /^[0-9\-]{7,13}$/g;
    if (!isPhone.test(value.toString()) && !isMob.test(value.toString())&& !regx.test(value.toString())) {
      callback(new Error());
    } else {
      callback();
    }
  },
  /*
   *根据字典查询站点功能
   */
  searchSiteCodeFunction(dicName = '') {
    if (dicName) {
      let property = {};
      this.getDictionary(dicName, (dic) => {
        property = this.$transformDicValue(dic[dicName]);
      });
      const siteCode = Cookies.get('siteCode');
      return property.hasOwnProperty(siteCode);
    }
  },
  /*
   *获取用户账号当前时区的时间  Date.now()是没转换的世界时间
   */
  getLocalTime() {
    return this.$momentElLocal(Date.now());
  },
  /**
   * 获取路线显示时间
   * 显示map_create_time，若是空取modem_record_time，若是空取gmt_create
   */
  getRouteTime(routeItem) {
    const time = routeItem.mapCreateTime || routeItem.modemRecordTime || routeItem.gmtCreate;
    return this.$momentLocal(time);
  },
  /**
   * 处理查询参数 如果是字符串拆成数组，如果是数组直接返回，其他类型返回空数组
   * @param {String|Array} param 查询参数
   */
  parseQueryParam(param) {
    // 如果是数组，直接返回
    if (Array.isArray(param)) {
      return param;
    }

    // 如果是字符串，按逗号分隔成数组
    if (typeof param === 'string') {
      return param
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item !== ''); // 去除空格
    }

    // 如果是其他类型，返回空数组或适当的处理
    return [];
  },
 /*
   * 根据 dateStr 格式化成日期范围数组
   * @param {String} dateStr 日期字符串
   * @param {String} format 日期格式
   * @return {Array} 日期范围数组
   */

  getDayRange(dateStr) {
     // 扩展支持的日期格式
    const dateFormats = [
      'YYYY-MM-DD',    // 标准连字符格式
      'YYYY/MM/DD',    // 斜杠格式
      'YYYYMMDD',      // 无分隔符格式
      'YYYY.MM.DD',    // 点分隔格式
      'DD-MM-YYYY',    // 欧洲日期格式
      'DD/MM/YYYY',    // 英联邦日期格式
      'MM-DD-YYYY',    // 美式日期格式
      'MM/DD/YYYY',    // 美式斜杠格式
      'YYYY-M-D',      // 单数字月份/日期
      'YYYY/M/D',      // 单数字斜杠格式
      'YYYY年MM月DD日' // 中文日期格式
    ];
    // 解析日期
     const date = moment(dateStr, dateFormats, true); // 严格模式解析
    if (!date.isValid()) {
      return dateStr;
    }
    const start =this.$momentWorld(date.startOf('day')) ;
    const end = this.$momentWorld(date.endOf('day'));
    return [start, end];
  },

};
